import React from 'react';
import { useParams } from 'react-router-dom';
import Layout from '~/src/components/Layout';
import LoadingBoundary from '~/src/components/LoadingBoundary';
import Profile from '~/src/components/PlayerSeason/Profile';
import Season from '~/src/components/PlayerSeason/Season';
import Header from '~/src/components/Team/Header';
import NotFound from '~/src/components/pages/NotFound';
import { Urls } from '~/src/lib/enums/urls';
import { OtePlayer } from '~/src/models/OtePlayer';
import useFetch from '~/src/overtime-lib/src/www/hooks/useFetch';
import './PlayerSeason.scss';

const _PlayerSeason = () => {
	const { id, season_id } = useParams();
	const fetchResult = useFetch<OtePlayer>({
		url: `${Urls.ApiRestOtePlayersUrl}/${id}`,
		key: 'ote_player',
	});
	const player = fetchResult.result?.read();
	if (!player) {
		return <NotFound />;
	}
	const team = player.ote_team;

	return (
		<div>
			<Header team={team} />
			<Profile player={player} team={team} />
			<Season player={player} season_id={season_id} />
		</div>
	);
};

const PlayerSeason = () => {
	return (
		<Layout>
			<div className="PlayerSeason">
				<LoadingBoundary>
					<_PlayerSeason />
				</LoadingBoundary>
			</div>
		</Layout>
	);
};
export default PlayerSeason;
